export default __webpack_public_path__ + "static/media/hostfully_step14.3df50f0e.png";